module.exports = __webpack_public_path__ + "static/media/Optimization.07849cc0.svg";